import script from "./AppBootError.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppBootError.vue?vue&type=script&setup=true&lang=ts"

import "./AppBootError.vue?vue&type=style&index=0&id=d9609e42&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9609e42"]])

export default __exports__